<!--studentView:学生查看页面 2024/05/28 11:31:27 XIJIGUO-->

<template>
  <div class="student-view">
    <div class="search-wrapper">
      <el-select v-model="classId" style="width:100px" size="mini" clearable placeholder="选择班级" @change="handleCurrentChange()">
        <el-option v-for="item in classList" :key="'class-' + item.id" :label="item.className" :value="item.id"></el-option>
      </el-select>

      <el-input size="mini" v-model="keyWord" @change="handleCurrentChange()" clearable placeholder="搜索(考号/姓名)" style="width: 186px;" suffix-icon="el-icon-search">
      </el-input>
    </div>
    <div class="tab-list">
      <ul class="tab-item">
        <li v-for="(item, index) in studentTypeList" :key="'tab' + index" :style="{ background: tabIdx == item.type ? '#ffffff' : '' }" @click="handleChangeType(item.type)">
          {{ item.name }}（{{ item.total }}） </li>
      </ul>
    </div>
    <div class="scan-paper-content">
      <div class="content-wrapper">
        <el-table v-loading="loading" :data="list" size="medium" border @selection-change="handleSelectionChange" style="width: 100%">
          <el-table-column align="center" type="selection" width="55" v-if="isDelete"></el-table-column>
          <el-table-column align="center" prop="className" label="班级"></el-table-column>
          <el-table-column align="center" prop="studNo" label="学号"></el-table-column>
          <el-table-column align="center" prop="examNo" label="考号"></el-table-column>
          <el-table-column align="center" prop="studName" label="姓名"></el-table-column>
          <el-table-column v-if="showSchool" align="center" prop="totScore" label="总分"></el-table-column>
          <el-table-column v-if="showSchool" align="center" prop="objScore" label="客观题"></el-table-column>
          <el-table-column v-if="showSchool" align="center" prop="subScore" label="主观题"></el-table-column>
          <el-table-column align="center" label="参与统计" :render-header="renderHeader">
            <template slot-scope="scope">
              <template v-if="scope.row.amentiaReason">
                <span> {{ scope.row.amentiaReason }}</span>
              </template>
              <span v-else-if="tabIdx <= 1 && scope.row.status == 1">
                <el-switch v-if="isPermission" @change="handleCountSwitch(scope.row.id)" v-model="scope.row.amentiaFlag" :active-value="1" :inactive-value="0"></el-switch>
                <el-switch v-else :disabled="true" v-model="scope.row.amentiaFlag" :active-value="1" :inactive-value="0"></el-switch>
              </span>
              <span v-else>{{ scope.row.amentiaFlag ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <div class="edit-list">
                <template v-if="scope.row.wayFlag !== 2">
                  <p v-if="scope.row.wayFlag === 1">
                    <span v-if="isPermission" @click="setDistinguishMark(scope.row, 5)">删除</span>
                    <el-link v-else disabled>删除</el-link>
                  </p>
                  <p v-if="scope.row.status == 0">
                    <span v-if="isPermission" @click="recordScore(scope.row,0)">编辑</span>
                    <el-link v-else disabled>编辑</el-link>
                  </p>
                </template>
                <p v-if="scope.row.flag === 0 || scope.row.flag === 3"> <span @click="recordScore(scope.row,1)">编辑</span>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="list-bottom">
        <div style="float: left;" v-if="isDelete">
          <el-button type="danger" size="small" :disabled="multipleSelection.length <= 0" plain @click="batchDelete()">批量删除</el-button>
          <el-button type="danger" size="small" plain @click="delTemplate()">删除全部成绩及模板</el-button>
        </div>
        <zj-pagination @current-change="handleCurrentChange" :page="{ current: pagination.current, size: pagination.pageSize, total: pagination.total }"></zj-pagination>
      </div>
    </div>

    <!-- 学生成绩录入 -->
    <yue-dialog custom-class="record-dialog" :title="currentStudent.studName + ' 编辑成绩'" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="780px" center>
      <el-form :inline="true" style="min-height: 200px" v-loading="recordScoreLoading">
        <div class="sub-header">
          <span class="horizontal-line"></span>
          <span style="background:white;font-weight:bold">客观题</span>
          <span v-if="objectiveQuestions.length > 0" style="float:right;font-weight:bold">客观题总分：{{ objectiveScoreAll }}</span>
        </div>
        <div v-if="objectiveQuestions.length == 0" style="height: 50px;line-height: 30px;text-align:center;color:#ccc;font-weight:bold">
          无客观题
        </div>
        <el-form-item :label="item.bigNum && item.smallNum ? item.bigNum + '.' + item.smallNum : item.question" v-for="item in objectiveQuestions" :key="'objective' + item.question">
          <el-input v-model="item.score" auto-complete="off" :maxlength="4" placeholder="得分" @change="isNumFunc(item.score, item.point,'objective')" :class="item.score > item.point ? 'colorRed' : ''"></el-input>
        </el-form-item>

        <div class="sub-header">
          <span class="horizontal-line"></span>
          <span style="background:white;font-weight:bold">主观题</span>
          <span v-if="subjectiveQuestions.length > 0" style="float:right;font-weight:bold">主观题总分：{{ subjectiveScoreAll }}</span>
        </div>

        <div v-if="subjectiveQuestions.length == 0" style="text-align:center;color:#ccc;font-weight:bold">
          无主观题
        </div>
        <el-form-item style="text-align: left;line-height: 20px;padding: 10px 0;vertical-align: baseline;" :label="item.bigNum && item.smallNum ? item.bigNum + '.' + item.smallNum : item.question" v-for="item in subjectiveQuestions" :key="'subjective' + item.question">
          <el-input v-model="item.score" auto-complete="off" :maxlength="4" placeholder="得分" @change="isNumFunc(item.score, item.point,'subjective')" :class="item.score > item.point ? 'colorRed' : ''"></el-input>
        </el-form-item>
        <div v-if="subjectiveQuestions.length > 0 || objectiveQuestions.length > 0" class="sub-header">
          <span style="float:right;font-weight:bold">总分：{{ subjectiveScoreAll + objectiveScoreAll }}</span>
        </div>
      </el-form>

      <template slot="footer">
        <span style="color:red;font-size:14px;">请修改完全部成绩后，点击考试列表-更多-重新生成单科报告，生成最新报告</span>
        <span class="dialog-footer" style="margin-top:10px;">
          <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="recordScoreBtnLoading" @click="updateDistinguishInput()">确 定</el-button>
        </span>
      </template>
    </yue-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import studentStatusEnum from '@/utils/enums/studentStatusEnum'
import ZjPagination from '@/pages/zujuan/components/ZjPagination.vue'
import { pauseWuhen } from '@/api/exam/marking'
import { getDistinguish, getDistinguishCount, getDistinguishList, setDistinguishExamType, delStudentAnswer, setDistinguishMark, deleteExamScans, getListAllStand, updateDistinguish } from '@/api/exam/exam'
import { examApi } from '@/v2/utils/api'

export default {
  name: 'studentView',
  components: { ZjPagination },
  props: {
    examInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      classId: '',
      keyWord: '',
      tabIdx: 1,
      objectiveScoreAll: 0,
      subjectiveScoreAll: 0,
      showReport: false, // 是否存在报告
      loading: false,
      isRegion: false, // 是否为区域统考
      showSchool: true, // 区域是否开放查看,默认为true，只有是统考且关闭时置为false
      dialogFormVisible: false,
      recordScoreLoading: false,
      recordScoreBtnLoading: false,

      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      currentStudent: {},

      studentTypeList: [
        {
          id: "UPLOAD",
          type: 1,
          name: "已导入",
          total: "0"
        },
        {
          id: "UN_UPLOAD",
          type: 2,
          name: "未导入",
          total: "0"
        },
      ],
      classList: [],
      list: [],
      multipleSelection: [],
      objectiveQuestions: [],
      subjectiveQuestions: [],
      questionKeyList: ['objective', 'subjective'],
      isUpdateScore: false, // 是否修改分数
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    isDelete () {
      // 已上传、未选科
      return [1, 10].indexOf(this.tabIdx) >= 0;
    },
    isPermission () {
      return (this.isRegion && this.userInfo.isAdmin) || !this.isRegion
    },
  },
  created () {
    this.schoolId = this.userInfo.schoolId
    if (this.examInfo.isMore === 2) {
      this.isRegion = true; // 是否为区域统考
      // 区域是否给学校查看
      this.showSchool = this.examInfo.showSchool == 0 ? false : true;
    }
    // 判断是否已经存在报告
    this.showReport = this.examInfo.reportState && this.examInfo.examSign
    this.refreshClassList();
    this.getDistinguishCount()
    this.handleCurrentChange(1);
  },
  methods: {
    refreshClassList () {
      let classList = [];
      const classes = this.examInfo.classes || []
      classes.forEach(item => {
        classList.push({
          id: item.id,
          className: item.className
        });
      })
      this.classList = classList;

      // 如果当前选中班级不存在了则清空选中班级
      if (this.classId && !classList.some(s => s.id === this.classId)) {
        this.classId = "";
      }
    },
    handleCurrentChange (val = 1) {
      this.pagination.current = val;
      this.getDistinguishList()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 获取识别统计
    getDistinguishCount () {
      let params = {
        classId: this.classId,
        examId: this.examInfo.id,
        schoolId: this.schoolId,
        keyWord: this.keyWord
      };
      getDistinguishCount(params).then(resp => {
        if (resp.success) {
          this.studentTypeList.forEach(item => {
            const type = resp.body.find(s => s.code === item.type)
            if (type) {
              item.total = type.count
            }
          })
        } else {
          this.$message.error(`获取失败, ${resp.message} !`);
        }

      }).catch(() => {
      });
    },
    // 获取识别列表
    getDistinguishList () {
      this.loading = true;
      const type = Object.keys(studentStatusEnum).find(key => {
        const emun = studentStatusEnum[key]
        if (emun) {
          return emun.code === this.tabIdx
        }
      });
      let params = {
        classId: this.classId,
        examId: this.examInfo.id,
        keyWord: this.keyWord,
        currentPage: this.pagination.current,
        pageSize: this.pagination.pageSize,
        schoolId: this.schoolId,
        type
      };
      getDistinguishList(params).then(resp => {
        this.loading = false;
        if (!resp.success) {
          this.list = [];
          this.pagination.total = 0;
          return;
        }

        resp.body.items.forEach(element => {
          element.ossUrl = this.fixUrl(element.ossUrl)
        })

        this.list = resp.body.items;
        this.pagination.total = resp.body.totalSize;
      }).catch(() => {
        this.list = [];
      })
    },
    // 参与统计切换
    handleCountSwitch (studId) {
      let result = this.list.find(item => item.id == studId);
      let type = result.amentiaFlag ? 6 : 7;
      this.setDistinguishMark(result, type);
    },
    // 1 标记缺考 2 标记取消缺考 3标记免考 4 标记取消免考 5 删除已录入 6 标记参与统计 7标记不参与统计 8 删除 ,
    setDistinguishMark (item, type) {
      item.resultId = item.resultId || item.id;

      let msg = "";
      switch (type) {
        case 1:
          msg = "是否标记该考生为缺考？";
          break;
        case 2:
          msg = "是否取消该考生缺考标记？";
          break;
        case 3:
          msg = "是否标记该考生为免考？";
          break;
        case 4:
          msg = "是否取消该考生免考标记？";
          break;
        case 5:
          msg = "是否确定删除该生成绩？";
          break;
        case 6:
          msg = "是否标记该考生本场考试参与统计？";
          break;
        case 7:
          msg = "是否标记该考生本场考试不参与统计？";
          break;
      }

      this.$confirm(msg, "提示").then(async () => {
        let params = {
          examId: this.examInfo.id,
          studentId: item.id,
        };

        this.loading = true;
        let resp
        switch (type) {
          case 1:
            params.flag = 1
            resp = await setDistinguishExamType(params)
            break;
          case 3:
            params.flag = 2
            resp = await setDistinguishExamType(params)
            break;
          case 2:
          case 4:
            params.flag = 0
            resp = await setDistinguishExamType(params)
            break;
          case 5:
            resp = await delStudentAnswer(params)
            break;
          case 6:
          case 7:
            params.flag = type == 6 ? 1 : 0
            resp = await setDistinguishMark(params)
            break;
        }
        this.loading = false;
        this.getDistinguishCount();
        this.getDistinguishList();
        if (resp.success) {
          this.$message.success("标记成功");

          switch (type) {
            case 1:
              item.flag = 1;
              break;
            case 2:
            case 4:
            case 5:
              item.flag = 0;
              break;
            case 3:
              item.flag = 2;
              break;
          }
        } else {
          this.$message.warning("标记失败" + resp.message);
        }
      }).catch(err => {
        if (type == 6 || type == 7) {
          item.amentiaFlag = item.amentiaFlag ? 0 : 1;
        }
      });
    },
    // 批量删除
    async batchDelete () {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择删除项");
        return;
      }
      try {
        let r = await this.$confirm("确定要批量删除选中学生的试卷吗", "提示");

        let studentIds = [];

        for (let item of this.multipleSelection) {
          studentIds.push(item.id);
        }

        let params = {
          examId: this.examInfo.id,
          studentIds
        };

        let res = await deleteExamScans(params);
        //  批阅中，无法删除状态
        if (res.code == 1004) {
          this.$confirm('是否确认暂停批阅（暂停后可进行删除操作）', '提示').then(() => {
            pauseWuhen({
              schoolId: this.schoolId,
              examId: this.examInfo.id
            }).then(resp => {
              if (resp.success) {
                this.$message.success('操作成功')
              }
            }).catch(() => { })
          })
          return
        }

        if (res.success) {
          this.$message.success("批量删除成功");
          this.multipleSelection = []
          this.getDistinguishList();
          this.getDistinguishCount();
        } else {
          this.$message.warning(res.message);
        }
      } catch (e) { }
    },
    // 手动录入学生成绩
    async recordScore (item, type) {
      this.objectiveScoreAll = 0;
      this.subjectiveScoreAll = 0;
      this.currentStudent = item;
      this.recordScoreLoading = true;
      let params = {
        examId: this.examInfo.id
      }
      const resp = await getListAllStand(params);
      let objectiveQuestions = [];
      let subjectiveQuestions = [];
      this.recordScoreLoading = false;
      if (resp.success) {
        let data = resp.body.examStandVos;
        for (let item of data) {
          if (item.choiceTypeCode == 1 || item.choiceTypeCode == 0) {
            objectiveQuestions.push({
              HalfChoiceParam: item.HalfChoiceParam,
              question: item.question,
              bigNum: item.bigNum,
              smallNum: item.smallNum,
              answer: "",
              num: item.num,
              standAnswer: item.answer,
              halfPoint: item.halfPoint,
              point: item.point,
              choiceType: item.choiceTypeCode,
              score: "",
            });
          }
          if (item.choiceTypeCode == 2) {
            subjectiveQuestions.push({
              question: item.question,
              bigNum: item.bigNum,
              smallNum: item.smallNum,
              score: "",
              point: item.point,
              num: item.num
            });
          }
        }

        this.objectiveQuestions = this.merageData(objectiveQuestions);
        this.subjectiveQuestions = this.merageData(subjectiveQuestions);
        if (type === 1) {
          await this.refreshScorce()
        }
        this.dialogFormVisible = true;
      }
    },
    // 题号去重
    merageData (data) {
      let newArr = [];
      let temp = {};
      for (var i in data) {
        var key = data[i].num;
        if (temp[key]) {
          temp[key].num = temp[key].num;
          temp[key].point = temp[key].point + data[i].point;
          temp[key].question = temp[key].question + " , " + data[i].question;
        } else {
          temp[key] = data[i];
          temp[key].num = data[i].num;
          temp[key].point = data[i].point;
        }
      }

      for (var k in temp) {
        newArr.push(temp[k]);
      }

      return newArr;
    },
    // 检测主观题输入分数是否正确
    isNumFunc (val, fullScore, key) {
      if (isNaN(val)) {
        return this.$message.warning("请输入数字！");
      }
      if (parseFloat(val) > parseFloat(fullScore)) {
        return this.$message.warning(`分数超过最大值${fullScore}`);
      }
      this.calculateScore(key);
    },
    // 刷新得分
    async refreshScorce () {
      let params = {
        resultId: this.currentStudent.resultId
          ? this.currentStudent.resultId
          : this.currentStudent.id,
        examId: this.examInfo.id
      };
      let resp = await getDistinguish(params);
      if (resp.success) {
        let data = resp.body.details;
        this.refreshQuestionScorce(data)
      }
    },
    // 刷新各试题得分
    refreshQuestionScorce (data) {
      for (let key of this.questionKeyList) {
        if (this[`${key}Questions`]) {
          for (let item of this[`${key}Questions`]) {
            const question = data.find(s => s.num + '' === item.num + '')
            if (question) {
              item.score = question.score + ''
            }
          }
          this.calculateScore(key)
        }
      }
    },
    calculateScore (key) {
      let total = 0;
      this[`${key}Questions`].map(s => {
        total += Number(s.score) || 0;
      });
      this[`${key}ScoreAll`] = total;
    },

    renderHeader (h, { column, $index }) {
      let html = h(
        "el-popover",
        {
          props: {
            placement: "top",
            trigger: "hover",
            effect: "dark",
            content:
              `更改参与统计后需在考试列表中点击 "重新生成报表" 按钮更新报表数据${(this.isRegion ? (this.gradingType === 3 ? '；省级联考' : '；区域联考') + ',单校管理员有权限控制是否参与统计' : '')}`
          }
        },
        [h("i", { slot: "reference", class: "el-icon-question" }, "")]
      );
      return h("span", {}, [h("span", {}, column.label), html]);
    },
    updateDistinguishInput () {
      for (let key of this.questionKeyList) {
        for (let item of this[`${key}Questions`]) {
          if (item.point && item.score && item.score > item.point) {
            this.$message.warning(`有${key === 'subjective' ? '主' : '客'}观题得分超出该题满分!`);
            return;
          }
        }
      }

      this.$confirm("确定保存编辑？", "确认").then(() => {
        let answerOrScore = {}
        for (let key of this.questionKeyList) {
          for (let item of this[`${key}Questions`]) {
            const value = item.score
            if (value != undefined) {
              answerOrScore[item.num] = String(value)
            }
          }
        }

        let params = {
          examId: this.examInfo.id,
          resultId: this.currentStudent.resultId,
          studentId: this.currentStudent.id,
          schoolId: this.schoolId,
          answerOrScore
        };

        this.recordScoreBtnLoading = true;
        updateDistinguish(params).then(resp => {
          this.getDistinguishCount();
          this.recordScoreBtnLoading = false;
          this.dialogFormVisible = false
          if (resp.success) {
            this.isUpdateScore = true
            this.getDistinguishList();
            this.$message.success("修改成功!");
          } else {
            this.$message.warning("保存失败，" + resp.message);
          }
        });
      })
    },
    handleChangeType (type) {
      if (this.loading) {
        return
      }
      this.tabIdx = type
      this.handleCurrentChange(1);
    },
    delTemplate () {
      const self = this
      this.$confirm('删除全部成绩后无法恢复，是否确认删除？', '提示').then(() => {
        this.loading = true
        let params = {
          examId: self.examInfo.id,
          schoolId: self.userInfo.schoolId,
          type: 3, // 1、清空模板 2、清空批阅记录 3、清空模板及批阅记录
          schoolType: self.userInfo.schoolType == 1 ? 0 : 1
        }

        examApi.clearExam(params).then(res => {
          if (res.success) {
            self.$message.success('删除成绩成功!')
            this.handleCurrentChange()
            this.getDistinguishCount();
          } else {
            self.$message.warning(res.message)
          }
        })
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isUpdateScore && !this.isRegion && this.showReport) {
      this.$root.$children[0].checkAndGenerateReport(this.examInfo.id, next)
    } else {
      next()
    }
  }
}
</script>

<style scoped lang="scss">
.student-view {
  min-height: 600px;
}

.student-view .search-wrapper {
  line-height: 40px;
  color: #333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding-left: 7px;
}

.student-view .tab-list {
  padding: 0px 2px;
}

.student-view .tab-item {
  height: 36px;
  line-height: 36px;
  font-size: 0;

  > li {
    min-width: 60px;
    padding: 0 16px;
    height: 36px;
    display: inline-block;
    font-size: 14px;
    text-align: center;
    color: #555;
    box-shadow: 0 0 1px #999;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: rgba(255, 255, 255, 0.6);
    }

    & .tab-actived {
      background: #fff;
    }

    &:last-child {
      margin-right: 3px;
    }
  }
}

.student-view .scan-paper-content {
  padding: 10px 15px 20px;
  border-radius: 4px;
  min-height: 400px;
  background: #fff;
}

.student-view .scan-paper-content .list-bottom {
  text-align: right;
  margin-top: 20px;
}

.student-view .scan-paper-content .edit-list {
  p {
    display: inline-block;
    width: 80px;
  }

  span {
    color: #2877ff;
    margin: 0 5px;
    display: inline-block;
    width: 70px;
    text-align: center;
    position: relative;
    cursor: pointer;

    &:hover {
      color: #777;
    }

    label {
      cursor: pointer;

      &:hover {
        color: #777 !important;
      }
    }

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 9;
    }
  }
}

.student-view .el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  width: 22%;
}
</style>

<style lang="scss">
.student-view .record-dialog .el-form-item__label {
  line-height: 22px;
  text-align: left;
}

.student-view .record-dialog .dialog-footer {
  justify-content: center;
}

.student-view .colorRed .el-input__inner {
  color: red !important;
}
</style>